import Mastercard from './mastercard.svg';
import Visa from './visa.svg';
import ApplePay from './applepay.svg';
import GPay from './gpay.svg';
import MoonPay from './moonpayLogo.svg';

// Mapping currency names to their respective components
export const paymentMethods: PaymentMethodsInterface = {
	mastercard: Mastercard,
	visa: Visa,
	applepay: ApplePay,
	gpay: GPay,
	moonpay: MoonPay,
};

export interface PaymentMethodsInterface {
	mastercard: React.FC<React.SVGProps<SVGSVGElement>>;
	visa: React.FC<React.SVGProps<SVGSVGElement>>;
	applepay: React.FC<React.SVGProps<SVGSVGElement>>;
	gpay: React.FC<React.SVGProps<SVGSVGElement>>;
	moonpay: React.FC<React.SVGProps<SVGSVGElement>>;
}
